module.exports = __webpack_public_path__ + "img/cpic.68bed523.jpg";